import React, { useState, useEffect } from "react";
import Data from "../App";
import CompView from "./CompView";
import { List, Map, is, fromJS } from "immutable";

const StreamGroup = ({ spec, editing, onChange }) => {
  function addNew() {
    console.log("addNew");
    let comp = new Map({
      type: "stream",
      name: "tbd",
      spec: "tbd"
    });
    let newId = Data.getInstance().addComp(comp);
    addId(newId);
  }

  function addId(newId) {
    if (!spec.get("streams")) {
      onChange(spec.set("streams", new List([newId])));
    } else {
      onChange(spec.updateIn(["streams"], list => list.push(newId)));
    }
  }

  let add = "";
  if (editing)
    add = (
      <div
        className="CompAddItem"
        onClick={e => {
          e.stopPropagation();
          addNew();
        }}
      >
        New Stream
      </div>
    );
  let streams = "";
  if (spec.get("streams"))
    streams = spec
      .get("streams")
      .map(streamId => <CompView compId={streamId} />);
  let state = "";
  if (spec.get("state")) state = <CompView compId={spec.get("state")} />;
  return (
    <div className="StreamGroup">
      <div className="Streams">
        {add}
        {streams}
      </div>
      {state}
    </div>
  );
};
export default StreamGroup;



// WEBPACK FOOTER //
// ./src/components/StreamGroup.js